<ng-container *ngIf="regionState$ | async as state">
  <header>
    <x-close-button (click)="regionService.closeOverlay()"></x-close-button>
    <div class="heading">
      <h2 class="text-capitalize">
        <ng-container i18n="@@RegionOverlay.ConfirmDeliveryArea.Title">
          Confirm your delivery area
        </ng-container>
      </h2>
      <div
        class="sub-heading mat-body-2"
        i18n="@@RegionOverlay.NormalFlow.ConfirmDeliveryArea.SubTitle"
      >
        Enter your shipping address to view all products available in your area.
      </div>
    </div>
  </header>

  <div class="body-content">
    <x-region-search>
      <button
        xAction
        mat-flat-button
        color="primary"
        (click)="regionService.confirm(state)"
        [disabled]="regionService.disableConfirm$ | async"
        class="confirm-button"
        i18n="@@CallToAction.Confirm"
      >
        Confirm
      </button>
    </x-region-search>

    @if (regionService.regionInActiveChannel(state)) {
      <div class="d-flex align-items-center justify-content-between">
        <x-region-delivery-details></x-region-delivery-details>
        <x-order-shipment-name
          *xIfShopConfig="'features.deliveryIndicator'"
        ></x-order-shipment-name>
      </div>
      <x-region-collect></x-region-collect>
    } @else if (state.region) {
      <x-region-goto-channel></x-region-goto-channel>
    }
  </div>
</ng-container>
